const SET_SPREADSHEET_IMPORT_ERROR = 'SET_SPREADSHEET_IMPORT_ERROR'
const SET_SPREADSHEET_IMPORT_STATUS = 'SET_SPREADSHEET_IMPORT_STATUS'

const _state = {
  spreadsheetImportError: null,
  spreadsheetImportStatus: 1,
}
const _getters = {
  spreadsheetImportError(state) {
    return state.spreadsheetImportError
  },
  spreadsheetImportStatus(state) {
    return state.spreadsheetImportStatus
  },
}
const actions = {
  setSpreadsheetImportErrorAction({ commit }, value) {
    commit(SET_SPREADSHEET_IMPORT_ERROR, value)
  },
  setSpreadSheetImportStatusAction({ commit }, value) {
    commit(SET_SPREADSHEET_IMPORT_STATUS, value)
  },
}
const mutations = {
  [SET_SPREADSHEET_IMPORT_ERROR](state, value) {
    state.spreadsheetImportError = value
  },
  [SET_SPREADSHEET_IMPORT_STATUS](state, value) {
    state.spreadsheetImportStatus = value
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
}
